export const MADE_TO_MEASURE_OPTIONS_REQUEST =
  "MADE_TO_MEASURE_OPTIONS_REQUEST";
export const MADE_TO_MEASURE_OPTIONS_SUCCESS =
  "MADE_TO_MEASURE_OPTIONS_SUCCESS";
export const MADE_TO_MEASURE_OPTIONS_FAIL = "MADE_TO_MEASURE_OPTIONS_FAIL";
export const MADE_TO_MEASURE_OPTIONS_RESET = "MADE_TO_MEASURE_OPTIONS_RESET";

export const MADE_TO_MEASURE_ENQUIRY_REQUEST =
  "MADE_TO_MEASURE_ENQUIRY_REQUEST";
export const MADE_TO_MEASURE_ENQUIRY_SUCCESS =
  "MADE_TO_MEASURE_ENQUIRY_SUCCESS";
export const MADE_TO_MEASURE_ENQUIRY_FAIL = "MADE_TO_MEASURE_ENQUIRY_FAIL";
export const MADE_TO_MEASURE_ENQUIRY_RESET = "MADE_TO_MEASURE_ENQUIRY_RESET";

export const MADE_TO_MEASURE_DRAFT_REQUEST =
  "MADE_TO_MEASURE_DRAFT_REQUEST";
export const MADE_TO_MEASURE_DRAFT_SUCCESS =
  "MADE_TO_MEASURE_DRAFT_SUCCESS";
export const MADE_TO_MEASURE_DRAFT_FAIL = "MADE_TO_MEASURE_DRAFT_FAIL";
export const MADE_TO_MEASURE_DRAFT_RESET = "MADE_TO_MEASURE_DRAFT_RESET";

export const MADE_TO_MEASURE_DRAFT_UPDATE_REQUEST =
  "MADE_TO_MEASURE_DRAFT_UPDATE_REQUEST";
export const MADE_TO_MEASURE_DRAFT_UPDATE_SUCCESS =
  "MADE_TO_MEASURE_DRAFT_UPDATE_SUCCESS";
export const MADE_TO_MEASURE_DRAFT_UPDATE_FAIL =
  "MADE_TO_MEASURE_DRAFT_UPDATE_FAIL";
export const MADE_TO_MEASURE_DRAFT_UPDATE_RESET =
  "MADE_TO_MEASURE_DRAFT_UPDATE_RESET";

export const MADE_TO_MEASURE_DRAFT_SUBMIT_REQUEST =
  "MADE_TO_MEASURE_DRAFT_SUBMIT_REQUEST";
export const MADE_TO_MEASURE_DRAFT_SUBMIT_SUCCESS =
  "MADE_TO_MEASURE_DRAFT_SUBMIT_SUCCESS";
export const MADE_TO_MEASURE_DRAFT_SUBMIT_FAIL =
  "MADE_TO_MEASURE_DRAFT_SUBMIT_FAIL";
export const MADE_TO_MEASURE_DRAFT_SUBMIT_RESET =
  "MADE_TO_MEASURE_DRAFT_SUBMIT_RESET";

export const MADE_TO_MEASURE_DRAFT_CLEAR_REQUEST =
  "MADE_TO_MEASURE_DRAFT_CLEAR_REQUEST";
export const MADE_TO_MEASURE_DRAFT_CLEAR_SUCCESS =
  "MADE_TO_MEASURE_DRAFT_CLEAR_SUCCESS";
export const MADE_TO_MEASURE_DRAFT_CLEAR_FAIL =
  "MADE_TO_MEASURE_DRAFT_CLEAR_FAIL";
export const MADE_TO_MEASURE_DRAFT_CLEAR_RESET =
  "MADE_TO_MEASURE_DRAFT_CLEAR_RESET";

export const MADE_TO_MEASURE_QUOTE_REQUEST =
  "MADE_TO_MEASURE_QUOTE_REQUEST";
export const MADE_TO_MEASURE_QUOTE_SUCCESS =
  "MADE_TO_MEASURE_QUOTE_SUCCESS";
export const MADE_TO_MEASURE_QUOTE_FAIL = "MADE_TO_MEASURE_QUOTE_FAIL";
export const MADE_TO_MEASURE_QUOTE_RESET = "MADE_TO_MEASURE_QUOTE_RESET";

export const MADE_TO_MEASURE_MY_REQUESTS_REQUEST =
  "MADE_TO_MEASURE_MY_REQUESTS_REQUEST";
export const MADE_TO_MEASURE_MY_REQUESTS_SUCCESS =
  "MADE_TO_MEASURE_MY_REQUESTS_SUCCESS";
export const MADE_TO_MEASURE_MY_REQUESTS_FAIL =
  "MADE_TO_MEASURE_MY_REQUESTS_FAIL";
export const MADE_TO_MEASURE_MY_REQUESTS_RESET =
  "MADE_TO_MEASURE_MY_REQUESTS_RESET";

export const MADE_TO_MEASURE_REQUEST_DETAILS_REQUEST =
  "MADE_TO_MEASURE_REQUEST_DETAILS_REQUEST";
export const MADE_TO_MEASURE_REQUEST_DETAILS_SUCCESS =
  "MADE_TO_MEASURE_REQUEST_DETAILS_SUCCESS";
export const MADE_TO_MEASURE_REQUEST_DETAILS_FAIL =
  "MADE_TO_MEASURE_REQUEST_DETAILS_FAIL";
export const MADE_TO_MEASURE_REQUEST_DETAILS_RESET =
  "MADE_TO_MEASURE_REQUEST_DETAILS_RESET";

export const MADE_TO_MEASURE_REQUEST_PAYMENT_REQUEST =
  "MADE_TO_MEASURE_REQUEST_PAYMENT_REQUEST";
export const MADE_TO_MEASURE_REQUEST_PAYMENT_SUCCESS =
  "MADE_TO_MEASURE_REQUEST_PAYMENT_SUCCESS";
export const MADE_TO_MEASURE_REQUEST_PAYMENT_FAIL =
  "MADE_TO_MEASURE_REQUEST_PAYMENT_FAIL";
export const MADE_TO_MEASURE_REQUEST_PAYMENT_RESET =
  "MADE_TO_MEASURE_REQUEST_PAYMENT_RESET";

export const MADE_TO_MEASURE_PAYMENT_STATUS_REQUEST =
  "MADE_TO_MEASURE_PAYMENT_STATUS_REQUEST";
export const MADE_TO_MEASURE_PAYMENT_STATUS_SUCCESS =
  "MADE_TO_MEASURE_PAYMENT_STATUS_SUCCESS";
export const MADE_TO_MEASURE_PAYMENT_STATUS_FAIL =
  "MADE_TO_MEASURE_PAYMENT_STATUS_FAIL";
export const MADE_TO_MEASURE_PAYMENT_STATUS_RESET =
  "MADE_TO_MEASURE_PAYMENT_STATUS_RESET";

export const MADE_TO_MEASURE_CUSTOMER_UPDATE_REQUEST =
  "MADE_TO_MEASURE_CUSTOMER_UPDATE_REQUEST";
export const MADE_TO_MEASURE_CUSTOMER_UPDATE_SUCCESS =
  "MADE_TO_MEASURE_CUSTOMER_UPDATE_SUCCESS";
export const MADE_TO_MEASURE_CUSTOMER_UPDATE_FAIL =
  "MADE_TO_MEASURE_CUSTOMER_UPDATE_FAIL";
export const MADE_TO_MEASURE_CUSTOMER_UPDATE_RESET =
  "MADE_TO_MEASURE_CUSTOMER_UPDATE_RESET";

export const MADE_TO_MEASURE_CUSTOMER_RESPONSE_REQUEST =
  "MADE_TO_MEASURE_CUSTOMER_RESPONSE_REQUEST";
export const MADE_TO_MEASURE_CUSTOMER_RESPONSE_SUCCESS =
  "MADE_TO_MEASURE_CUSTOMER_RESPONSE_SUCCESS";
export const MADE_TO_MEASURE_CUSTOMER_RESPONSE_FAIL =
  "MADE_TO_MEASURE_CUSTOMER_RESPONSE_FAIL";
export const MADE_TO_MEASURE_CUSTOMER_RESPONSE_RESET =
  "MADE_TO_MEASURE_CUSTOMER_RESPONSE_RESET";

export const MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_REQUEST =
  "MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_REQUEST";
export const MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_SUCCESS =
  "MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_SUCCESS";
export const MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_FAIL =
  "MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_FAIL";
export const MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_RESET =
  "MADE_TO_MEASURE_ACCEPT_CUSTOMER_UPDATE_RESET";

export const MADE_TO_MEASURE_ADMIN_LIST_REQUEST =
  "MADE_TO_MEASURE_ADMIN_LIST_REQUEST";
export const MADE_TO_MEASURE_ADMIN_LIST_SUCCESS =
  "MADE_TO_MEASURE_ADMIN_LIST_SUCCESS";
export const MADE_TO_MEASURE_ADMIN_LIST_FAIL =
  "MADE_TO_MEASURE_ADMIN_LIST_FAIL";

export const MADE_TO_MEASURE_ADMIN_UPDATE_REQUEST =
  "MADE_TO_MEASURE_ADMIN_UPDATE_REQUEST";
export const MADE_TO_MEASURE_ADMIN_UPDATE_SUCCESS =
  "MADE_TO_MEASURE_ADMIN_UPDATE_SUCCESS";
export const MADE_TO_MEASURE_ADMIN_UPDATE_FAIL =
  "MADE_TO_MEASURE_ADMIN_UPDATE_FAIL";
export const MADE_TO_MEASURE_ADMIN_UPDATE_RESET =
  "MADE_TO_MEASURE_ADMIN_UPDATE_RESET";

export const MADE_TO_MEASURE_ADMIN_QUOTE_REQUEST =
  "MADE_TO_MEASURE_ADMIN_QUOTE_REQUEST";
export const MADE_TO_MEASURE_ADMIN_QUOTE_SUCCESS =
  "MADE_TO_MEASURE_ADMIN_QUOTE_SUCCESS";
export const MADE_TO_MEASURE_ADMIN_QUOTE_FAIL =
  "MADE_TO_MEASURE_ADMIN_QUOTE_FAIL";
export const MADE_TO_MEASURE_ADMIN_QUOTE_RESET =
  "MADE_TO_MEASURE_ADMIN_QUOTE_RESET";

export const MADE_TO_MEASURE_PUBLIC_QUOTE_REQUEST =
  "MADE_TO_MEASURE_PUBLIC_QUOTE_REQUEST";
export const MADE_TO_MEASURE_PUBLIC_QUOTE_SUCCESS =
  "MADE_TO_MEASURE_PUBLIC_QUOTE_SUCCESS";
export const MADE_TO_MEASURE_PUBLIC_QUOTE_FAIL =
  "MADE_TO_MEASURE_PUBLIC_QUOTE_FAIL";
export const MADE_TO_MEASURE_PUBLIC_QUOTE_RESET =
  "MADE_TO_MEASURE_PUBLIC_QUOTE_RESET";

export const MADE_TO_MEASURE_ACCEPT_QUOTE_REQUEST =
  "MADE_TO_MEASURE_ACCEPT_QUOTE_REQUEST";
export const MADE_TO_MEASURE_ACCEPT_QUOTE_SUCCESS =
  "MADE_TO_MEASURE_ACCEPT_QUOTE_SUCCESS";
export const MADE_TO_MEASURE_ACCEPT_QUOTE_FAIL =
  "MADE_TO_MEASURE_ACCEPT_QUOTE_FAIL";
export const MADE_TO_MEASURE_ACCEPT_QUOTE_RESET =
  "MADE_TO_MEASURE_ACCEPT_QUOTE_RESET";
